document.addEventListener('turbo:load', () => {
  const navbar = document.getElementById('navbar')
  const topBar = document.querySelector('.f1-top-bar')
  const navItems = navbar.querySelectorAll('.navbar-nav > .dropdown')

  const isMobileNav = () => getComputedStyle(document.querySelector('.check-for-mobile')).float === 'none'
  const isTablet = () => window.outerWidth > 767 && window.outerWidth < 1025

  let lastScrollState = null

  const dropdowns = document.querySelectorAll('.dropdown.navbar-dropdown')

  dropdowns.forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle')

    toggle.addEventListener('click', e => {
      e.preventDefault()

      dropdowns.forEach(other => {
        if (other !== dropdown) {
          other.querySelector('.dropdown-toggle').classList.remove('show')
          other.querySelector('.secondary-menu').classList.remove('show')
        }
      })
    })
  })

  const updateNavbarTop = () => {
    if (lastScrollState) {
      navbar.style.top = '0'
    } else if (topBar) {
      navbar.style.top = topBar.offsetHeight + 'px'
    }
  }

  const toggleTopBar = () => {
    const scrolledNow = window.scrollY >= 80
    if (scrolledNow === lastScrollState) return

    lastScrollState = scrolledNow

    if (scrolledNow) {
      navbar.classList.add('scrolled')
      navbar.querySelectorAll('.navbar-brand, .navbar-collapse, .navbar-nav')
        .forEach(el => el.classList.add('scrolled'))
      document.body.classList.add('navbar-is-collapsed')
      if (topBar) {
        topBar.style.height = '0'
        topBar.style.opacity = '0'
      }
    } else {
      navbar.classList.remove('scrolled')
      navbar.querySelectorAll('.navbar-brand, .navbar-collapse, .navbar-nav')
        .forEach(el => el.classList.remove('scrolled'))
      document.body.classList.remove('navbar-is-collapsed')
      if (topBar) {
        topBar.style.height = ''
        topBar.style.opacity = '1'
      }
    }

    updateNavbarTop()
  }

  toggleTopBar()

  navbar.querySelectorAll('.navbar-nav li a').forEach(link => {
    const href = link.getAttribute('href')
    if (href !== '#' && window.location.href.includes(href)) link.classList.add('active-link')
  })

  window.addEventListener('scroll', toggleTopBar)

  navItems.forEach(item => {
    const toggle = item.querySelector('.dropdown-toggle')
    toggle.addEventListener('click', e => {
      if (isMobileNav() || isTablet()) {
        e.preventDefault()
        e.stopPropagation()
        item.classList.remove('open')
      } else {
        item.querySelector('.dropdown-menu')?.classList.add('display')
        item.classList.add('open', 'dropdown-hover')
      }
    })
  })
})
